import * as React from 'react';

import OrganizationSubscriptions from '../../organizations/components/organization-subscriptions/OrganizationSubscriptions';

import BaseAgencyPage from './BaseAgencyPage';

import { t } from 'utils/language';

import type { Params } from 'types';

type Props = {
  params: Params
};

const AgencySubscriptionsPage = ({
  params
}: Props) => (
  <BaseAgencyPage
    id={Number(params.id)}
    documentTitle={t('agency_subscriptions_page_title')}
    renderChildren={() => (
      <OrganizationSubscriptions
        key={params.id}
        organizationId={Number(params.id)}
      />
    )}
  />
);

export default AgencySubscriptionsPage;
